<!-- BMIのチャート -->
<template>
  <div class="small">
    <line-chart :chartdata="chartdata" :options="options" :width="1000"></line-chart>
  </div>
</template>


<script>
import VueTypes from "vue-types";
import LineChart from "./LineChart.js";

export default {
  components: {
    LineChart
  },
  data() {
    return {
      options: {
        responsive: true,
        scales: {
          yAxes: [
            {
              ticks: {
                suggestedMax: 30,
                suggestedMin: 10,
                stepSize: 5
              }
            }
          ]
        }
      }
    };
  },
  props: {
    label: VueTypes.arrayOf(VueTypes.string).isRequired,
    weight: VueTypes.arrayOf(VueTypes.number).def(0),
    height: VueTypes.number.isRequired
  },
  computed: {
    culcBmi: function() {
      /* BMIの算出(weight / (height * height))
         各値を配列に格納して返す。
      */
      return this.weight.map(element =>
        (element / (this.height / 100) ** 2).toFixed(0)
      );
    },
    chartdata() {
      return {
        labels: this.label,
        datasets: [
          {
            label: this.$t('notebook.legendBMI'),
            borderColor: "#95BE91",
            backgroundColor: "rgba(0, 0, 0, 0)",
            lineTension: 0,
            data: this.culcBmi
          }
        ]
      }
    }
  }
};
</script>

<style scoped>
.small {
  margin: auto;
}
</style>